export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12600.d1858f74.jpg";